import React from 'react';

import styled from '@emotion/styled';

import Card from '../../../components/Cards/Card';
import PersonIcon from '../../../components/Icons/PersonIcon';
import ProfileListIcon from '../../../components/Icons/ProfileListIcon';
import { useAppSelector } from '../../../redux/store';

const KycOverview = () => {
  const { dashboardStatsData } = useAppSelector((state) => state.dashboardData);

  return (
    <Container>
      <CardTitle>OVERVIEW</CardTitle>
      <CardContainerWrapper>
        {/* Left */}
        {/* <LeftCardsContainer> */}
        {/* Card 1 */}
        <Card.Root padding='12px 24px'>
          <Card.Header padding='12px'>
            <PersonIcon /> Approved Partners
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.approvedPartners ?? 0}
            </Card.LargeNumber>
          </Card.Body>

          {/* <Card.ControlledBodyText>
            Last approval: 2 hrs ago
          </Card.ControlledBodyText> */}
        </Card.Root>

        {/* Card 2 */}
        <Card.Root padding='12px 24px'>
          <Card.Header padding='12px'>
            <ProfileListIcon /> Pending Partners
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.pendingKycRequests ?? 0}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>

        {/* Card 3 */}
        <Card.Root padding='12px 24px'>
          <Card.Header padding='12px'>
            <ProfileListIcon /> Rejected Partners
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.rejectedPartners ?? 0}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>
      </CardContainerWrapper>
    </Container>
  );
};

export default KycOverview;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const CardContainerWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;
  height: 160px;
  /* border: 1px solid red; */
`;

const CardTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 16px;
  line-height: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
